import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, map, of, switchMap, take } from 'rxjs';

const ROLES_CLAIM = 'https://docuty.com/roles';
const SYSTEM_ADMIN_ROLE = 'SystemAdmin';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isLoginPage = state.url === '/login' || state.url.startsWith('/login?');

  return auth.isLoading$.pipe(
    filter(loading => !loading),
    take(1),
    switchMap(() => auth.isAuthenticated$),
    take(1),
    switchMap(isAuthenticated => {
      if (!isAuthenticated && !isLoginPage) {
        sessionStorage.setItem('redirectUrl', state.url);
        return of(router.createUrlTree(['/login']));
      }

      if (!isAuthenticated && isLoginPage) {
        return of(true);
      }

      // User is authenticated
      if (!isLoginPage) {
        // Let systemAdminGuard handle the role check for protected routes
        return of(true);
      }

      // Authenticated user on /login: only redirect to dashboard if they have the SystemAdmin role.
      // Without this check, non-admin users would be redirected to /dashboard, which
      // systemAdminGuard blocks, creating an infinite redirect loop.
      return auth.user$.pipe(
        take(1),
        map(user => {
          const roles: string[] = (user as any)?.[ROLES_CLAIM] ?? [];
          if (roles.includes(SYSTEM_ADMIN_ROLE)) {
            return router.createUrlTree(['/dashboard']);
          }
          // Authenticated but not a SystemAdmin → stay on /login (no loop)
          return true;
        })
      );
    })
  );
};
